module.exports = __webpack_public_path__ + "static/bluevelourbunny-8963637e08995efe7794d8b3609be994.jpeg";